/**
 * Bingo Scheduler Portlet Model
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var $ = require('j');
    var server = require('server');
    var user = require('user');
    var config = require('config');

    module.exports = {
        lobbyRequestParams: [
            'region',
            'version',
            'uniqueJackpots',
            'casino',
            'lobbyName'
        ],

        scheduleGamesRequestParams: [
            'region',
            'version',
            'casino',
            'lobbyName',
            'schedulePeriod',
            'scheduleDay',
            'pageNumber',
            'pageSize'
        ],

        getAll: function(params) {
            return $.when(
                this.getScheduledGamesRequest(params),
                this.getLobbyRequest(params)
            ).then(function(response1, response2) {
                return _.extend({}, response1, {
                    siteSchedules: this.extendSiteSchedules(
                        response1.siteSchedules,
                        response2.games
                    )
                });
            }.bind(this));
        },

        getScheduledGamesRequest: function(extraParams) {
            return server.send(_.extend({
                ID: 81710,
                description: 'Bingo scheduled games request',
                responses: [81711, 81712],
                region: this._getRegion(),
                version: undefined,
                casino: config.get('casinoName'),
                lobbyName: undefined,
                schedulePeriod: 0, // Nearest Time
                scheduleDay: parseInt(new Date().getDay() + 1),
                pageNumber: 1,
                pageSize: 10
            }, _.pick(extraParams, this.scheduleGamesRequestParams)))
                .then(function(response) {
                    return {
                        siteSchedules: response.data.siteSchedules,
                        allCount: response.data.totalAmount,
                        currentPage: response.data.pageNumber - 1
                    };
                });
        },

        getLobbyRequest: function(extraParams) {
            return server.send(_.extend({
                ID: 81701,
                description: 'Bingo Lobby request',
                responses: [81702, 81703],
                region: this._getRegion(),
                version: undefined,
                uniqueJackpots: true,
                casino: config.get('casinoName'),
                lobbyName: undefined
            }, _.pick(extraParams, this.lobbyRequestParams)))
                .then(function(response) {
                    return response.data;
                });
        },

        extendSiteSchedules: function(siteSchedules, gamesInfo) {
            var findGame = function(gameName) {
                return function(gameInfo) {
                    return gameInfo.gameName === gameName;
                };
            };

            return _.map(siteSchedules, function(scheduleInfo) {
                var cardPrice = _.pick(scheduleInfo, 'cardPrice');
                return _.extend({}, scheduleInfo, _.find(gamesInfo, findGame(scheduleInfo.name)), cardPrice);
            });
        },

        _getRegion: function() {
            var location = _.findWhere(config.get('locationJson.items'), {
                countryCode: user.get('userDetails') && user.get('userDetails').countryCode
            });

            return location && location.region || config.get('defaultBingoRegion');
        }

    };
});
